// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import Vant from 'vant';
// import "./plugins";
import 'vant/lib/index.css';
// import Vconsole from 'vconsole'
import '@/assets/styles/index.scss' // global css

import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs// 全局使用dayjs
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(Vant);
Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js